<template>
  <div>
    <template v-if="isSignedIn">
      <Dashboard :userInfo="userInfo"/>
    </template>
    <template v-else>
      <section class="hero is-large main-hero">
        <div class="hero-body">
          <div class="container">
            <h1 class="title">
              Lorem ipsum dolor sit amet
            </h1>
            <h2 class="subtitle">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi feugiat velit vitae blandit tempus. Donec consequat sodales pellentesque. Nullam ex ex, rutrum sit amet arcu at, consequat dictum neque. Pellentesque congue magna ut vulputate consequat. Sed ultricies ipsum eu tempor gravida.
            </h2>
          </div>
        </div>
      </section>
      <section class="section">
        <div class="container">
          <div class="columns">
            <div class="column">
              <!-- FIXME: Look at using box class instead -->
              <div class="card">
                <div class="card-header">
                  <span class="card-header-title">
                    Component
                  </span>
                </div>
                <div class="card-content">
                  <div class="content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc venenatis porttitor felis eu sagittis. Phasellus varius pulvinar quam, lobortis aliquet nisl pharetra in. Nunc tempor dui id varius aliquam. Cras quis ex ante. Nulla molestie lacus ut purus fringilla condimentum. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec a dapibus sem. Duis porta eros at lorem lacinia varius. 
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="card">
                <div class="card-header">
                  <span class="card-header-title">
                    Component
                  </span>
                </div>
                <div class="card-content">
                  <div class="content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec quis rutrum augue, ut ultrices lorem. Curabitur laoreet pharetra rutrum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Mauris rhoncus leo quis dolor consectetur, quis vulputate sapien sagittis. Maecenas vulputate in nunc fringilla dignissim. Nam posuere nisl nec dolor pharetra porta. Donec tincidunt, leo id porta mattis, velit est ultrices odio, non maximus nisi mi et urna. Fusce semper lobortis dictum. Praesent ut hendrerit libero. 
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="card">
                <div class="card-header">
                  <span class="card-header-title">
                    Component
                  </span>
                </div>
                <div class="card-content">
                  <div class="content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus volutpat vestibulum metus, ac vehicula quam feugiat eu. Donec nec lacus vulputate, faucibus est eget, ullamcorper felis. Vestibulum laoreet vestibulum neque quis cursus. In a accumsan risus. Etiam a tempor ipsum. Aenean vitae gravida lorem. Ut est neque, volutpat quis sodales ultrices, consequat eget est. 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import Dashboard from '@/components/dashboard/Home';

export default {
  name: 'Home',
  props: ['userInfo', 'isSignedIn'],
  components: {
    Dashboard,
  },
}
</script>

<style scoped>
.main-hero {
  /* background: url('../assets/logo.png') center center; */
  background: linear-gradient(115deg, #f5f5f5, #f5f5f5 60%, #00d1b2);
  background-size: cover;
}
</style>